import {useSyncExternalStore} from 'react';

const subscribe = (listener: () => void) => {
    window.addEventListener('online', listener);
    window.addEventListener('offline', listener);
    return () => {
        window.removeEventListener('online', listener);
        window.removeEventListener('offline', listener);
    };
};

const read = () => (typeof navigator === 'undefined' ? true : navigator.onLine);

/** navigator.onLine, live. Optimistic by nature: "online" only means a network interface is up. */
export const useOnline = () => useSyncExternalStore(subscribe, read, () => true);

/** Resolves when the browser reports being online (immediately if it already is). */
export const whenOnline = (): Promise<void> =>
    read()
        ? Promise.resolve()
        : new Promise(resolve => {
              const done = () => {
                  window.removeEventListener('online', done);
                  resolve();
              };
              window.addEventListener('online', done);
          });
